import { FlexRow } from '@/components/common/Flex';
import Notice from '@/components/common/Notice';
import { Divider, FlexProps } from '@chakra-ui/react';
import {
    isFailedTransactionStatus,
    TransactionProps,
} from '@common/react/transactions';
import { FlexCol } from '../common/Flex';
import { EyebrowHeader } from '../common/Typography';
import TransactionProgress from '../transactions/TransactionProgress';
import TransactionSourceOrDestinationLockup from './TransactionSourceOrDestinationLockup';

export interface GoalTransactionStatusViewProps extends FlexProps {
    transaction: TransactionProps;
    subtitle?: React.ReactNode;
}

const GoalTransactionStatusView = ({
    transaction,
    ...props
}: GoalTransactionStatusViewProps) => {
    const isFailed = isFailedTransactionStatus(transaction.status);

    return (
        <FlexCol {...props}>
            {transaction.amountChangedReason ===
                'BALANCE_REDUCED_DUE_TO_FEES' && (
                <Notice mb={8}>
                    The amount was reduced from your original request to cover
                    fees in your account.
                </Notice>
            )}
            {transaction.amountChangedReason === 'ATOMIC' && (
                <Notice mb={8}>
                    The transfer amount was reduced from your original request
                    because the value of your investments changed between the
                    time you submitted the withdrawal request, and when the
                    investments were sold. If you have any questions, please
                    reach out to us at members@withplenty.com.
                </Notice>
            )}
            <FlexCol h={24} pt={4}>
                <EyebrowHeader fontSize="sm" mb={2}>
                    From
                </EyebrowHeader>
                <FlexRow align="center">
                    <TransactionSourceOrDestinationLockup
                        financialEntityId={transaction.sourceId}
                    />
                </FlexRow>
            </FlexCol>
            <Divider />
            <FlexCol h={24} pt={4}>
                <EyebrowHeader fontSize="sm" mb={2}>
                    To
                </EyebrowHeader>
                <FlexRow align="center">
                    <TransactionSourceOrDestinationLockup
                        financialEntityId={transaction.destinationId}
                    />
                </FlexRow>
            </FlexCol>
            <Divider />
            {!isFailed && (
                <>
                    <EyebrowHeader fontSize="sm" mt={6} mb={2}>
                        Progress
                    </EyebrowHeader>
                    <TransactionProgress transaction={transaction} />
                </>
            )}
        </FlexCol>
    );
};

export default GoalTransactionStatusView;
